import React from 'react';
import { observer } from 'mobx-react';
import List from '../list/ListComponent';
import TableRow from './components/tableRow/TableRow';
import StackLayout from '../stackLayout/StackLayoutComponent';
var TableComponent = function (props) {
    var children = props.children, data = props.data, rowHeight = props.rowHeight, emptyRenderer = props.emptyRenderer;
    return (React.createElement(StackLayout, { stretch: true },
        React.createElement(TableRow, { activeTableTheme: 0 }, children),
        React.createElement(StackLayout, { stretch: true },
            React.createElement(List, { emptyRenderer: emptyRenderer, items: data, itemRenderer: function (item, index) { return (React.createElement(TableRow, { activeTableTheme: 0, rowIndex: index - 1, item: item }, children)); }, itemHeight: function (rowIndex) {
                    if (rowIndex === 0) {
                        return 20; // ToDo: use header height!
                    }
                    if (rowHeight) {
                        return rowHeight(rowIndex - 1);
                    }
                    return 10; // ToDo: from active theme variant
                } }))));
};
export default observer(TableComponent);
//# sourceMappingURL=TableComponent.js.map